import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormDetail } from "../../../../../redux/slice/form";
import { useHookForm } from "../../../../../components/hooks";

import { FormRadio } from "../../../../../components/formElement";
import { option_control_satisfaction } from "../../../../../service/option";

import ImgQuestion from "../../../../../images/other/question_icon.PNG";

import { Button } from "primereact/button";

export default function ModuleControlStep6(props) {
  const { onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  // 表單欄位預設值
  const defaultValues = {
    e1: null,
    e2: null,
    e3: null,
    e4: null,
  };
  const { handleSubmit, reset, yup, setSchema, setting } = useHookForm({
    defaultValues,
  });

  useEffect(() => {
    setSchema(
      yup
        .object({
          e1: yup.number().required("必填").nullable(),
          e2: yup.number().required("必填").nullable(),
          e3: yup.number().required("必填").nullable(),
          e4: yup.number().required("必填").nullable(),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    if (redux_form.formDetail?.step6) {
      reset(redux_form.formDetail.step6);
    }
  }, [redux_form]);

  const onSubmit = (submitData) => {
    let jsonData = {
      ...redux_form.formDetail,
      step6: submitData,
    };
    dispatch(setFormDetail(jsonData));

    onTabChange({ index: 6 });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="text-lg">
        <div className="flex align-items-center text-2xl font-bold mb-3">
          <img className="mr-2" src={ImgQuestion} alt="Question" />
          滿意度調查
        </div>

        <div className="mt-2 ml-2">
          {option_control_satisfaction.map((item, index) => (
            <div key={item.value} className="mb-2">
              <div className="flex align-items-start text-lg font-bold">
                <div
                  className="inline-flex align-items-center justify-content-center flex-shrink-0 text-white bg-red-500 border-1 border-500 border-circle mr-2"
                  style={{
                    width: "1.7rem",
                    height: "1.7rem",
                    lineHeight: "1.7rem",
                  }}
                >
                  {index + 1}
                </div>
                <div>{item.label}</div>
              </div>
              <div className="flex flex-wrap pl-5">
                {item.options.map((option) => (
                  <FormRadio
                    key={`q_${option.value}`}
                    setting={setting}
                    data={{
                      name: `e${index + 1}`,
                      label: option.label,
                      value: option.value,
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-sm my-6">
          <div className="mb-1">出版日期：預計2023年10月7日 進行更新</div>
          <div>更新日期：預計2023年11月7日 進行更新</div>
        </div>

        <div className="col-12 text-center my-3">
          <Button
            className="p-button-warning text-white px-3 rotate-icon-x-180"
            type="button"
            label="上一步：決定"
            icon="fa fa-reply bg-main border-round-md p-1"
            onClick={() => onTabChange({ index: 4 })}
          />
          <Button
            className="p-button-warning text-white ml-3 px-3 rotate-icon-xy-180 rotate-icon-y-180"
            type="submit"
            label="參考資料"
            icon="fa fa-reply bg-main border-round-md p-1"
          />
        </div>
      </form>
    </>
  );
}
